import { FileText } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { InsuranceIndication } from '../../models/insuranceIndication'

export interface QuoteDocumentsDialogProps {
  indication: InsuranceIndication
}

/**
 * CAI-admin-only dialog listing quote PDFs attached from Rocklake email
 * ingestion — mirrors IndicationScreenshotsDialog but for downloadable PDFs.
 */
export function QuoteDocumentsDialog({ indication }: QuoteDocumentsDialogProps) {
  const documents = indication.quoteDocuments ?? []
  if (documents.length === 0) return null

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button size="sm" variant="link">
          Quote PDFs ({documents.length})
          <FileText className="h-3 w-3" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{indication.vendorName} quote documents</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3">
          {documents.map((document) => (
            <div key={document.id} className="flex items-center justify-between gap-4">
              {document.url ? (
                <a
                  href={document.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink hover:text-ink/80 text-sm font-medium break-all"
                >
                  {document.fileName}
                </a>
              ) : (
                <span className="text-sm font-medium break-all">{document.fileName}</span>
              )}
              <span className="text-muted-foreground text-xs whitespace-nowrap">
                {new Date(document.dateCreated).toLocaleDateString()}
              </span>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
